import { Link } from 'react-router-dom';
import { PencilSquare } from 'react-bootstrap-icons';

/**
 * @param {object} apiRef - MUI Data Grid `useGridApiRef()` result
 * @param {{ remarksEditable?: boolean }} [options] - When true, Remarks (`contract_status`) is editable and the pencil starts cell edit. Default false for list tabs that hide the icon column.
 */
export const getRequestDataColumn = (apiRef, options = {}) => {
  const { remarksEditable = false } = options;

  return [
    {
      field: 'pr_no',
      headerName: 'PR Number',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <Link
            to={'/purchasing/purchaseRequest/show/' + row.pr_hdr_id}
            className="text-blue"
          >
            {row.pr_no}
          </Link>
        );
      },
    },
    {
      field: 'pr_date',
      headerName: 'PR Date',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'department',
      headerName: 'Department',
      minWidth: 150,
      flex: 1,
      valueGetter: ({ row }) =>
        row.get_user?.get_department?.department_name ?? '',
    },
    {
      field: 'employee',
      headerName: 'Employee',
      minWidth: 150,
      flex: 1,
      valueGetter: ({ row }) => row.get_user?.employee_name ?? '',
    },
    {
      field: 'product_name',
      headerName: 'Item Description',
      minWidth: 150,
      flex: 1,
      valueGetter: ({ row }) =>
        row.get_details
          .map((dat) => dat.product_details.product_name)
          .join(', '),
    },
    {
      field: 'estimated_delivery_date',
      headerName: 'Date Needed',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'particulars',
      headerName: 'Particulars',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'contract_status',
      headerName: 'Remarks',
      minWidth: 150,
      flex: 1,
      editable: remarksEditable,
    },
    {
      field: 'po_status',
      headerName: 'PO Status',
      minWidth: 150,
      flex: 1,
      hide: false,
      renderCell: ({ row }) => {
        if (row.get_po_details) {
          let status = row.get_po_details?.approved_status;

          if (parseInt(status) === 0) {
            return <span className="badge badge-info">Officer Aproval</span>;
          }

          if (parseInt(status) === 1) {
            return <span className="badge badge-success">Approved</span>;
          }

          if (parseInt(status) === 2) {
            return <span className="badge badge-danger">Cancelled</span>;
          }

          if (parseInt(status) === 3) {
            return <span className="badge badge-default">Editing</span>;
          }

          if (parseInt(status) === 4) {
            return <span className="badge badge-info">For VP Approval</span>;
          }

          if (parseInt(status) === 5) {
            return <span className="badge badge-info">President Approval</span>;
          }

          if (parseInt(status) === 6) {
            return <span className="badge badge-info">Manager Approval</span>;
          }
        }

        return '';
      },
    },
    {
      field: 'icon',
      headerName: <PencilSquare size={18} />,
      width: 50,
      hide: false,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <button
            type="button"
            className="btn btn-link p-0 text-blue border-0"
            title={`Edit remarks for ${row.pr_no ?? ''}`}
            disabled={!remarksEditable}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (!remarksEditable) return;
              apiRef.current?.startCellEditMode({
                id: row.pr_hdr_id,
                field: 'contract_status',
              });
            }}
          >
            <PencilSquare size={18} />
          </button>
        );
      },
    },
  ];
};
